import React, { useEffect, useState } from 'react';
import getHours from 'date-fns/getHours';
import isAfter from 'date-fns/isAfter';
import isBefore from 'date-fns/isBefore';
import isEqual from 'date-fns/isEqual';
import faciltiesFilters from './facilities-filters';

function filterByValue (key, val) {
    return function (item) {
        return item.attributes[key] == val;
    }
}

function stringToarray( arrayOnString ){    
    let temp = arrayOnString.replace(/\[/g, "");
    let temp2 = temp.replace(/]/g, "");
    return temp2.split(','); 
}

export default function (filters = {}, programs = []) { //Add the object as attribute to use its data and filtered
    const {
        ageRange,
        dow = '',
        gender,
        end,
        location,
        facility,
        season,
        skillLevel,
        start,
        time,
        type,
        age,
        length
    } = filters;
    const [ results, setResults ] = useState([]);

    async function fetch () {
        
        let results = programs;//window.LEAGUES || window.TEAMS;
        if (type) {
            const typeId = Object.keys(window.TYPES)
                .find(key =>
                    new RegExp(type, 'i').test(window.TYPES[key])
                )
            ;

            if (typeId) {                
                results = results.filter(filterByValue('program_type_id', typeId));                
            }
        }

        if (age) {
            // 3-5	
            // 4-5	
            // 4-8	
            // 5-8	
            // 6-8	
            // 7-9	
            // 8-10	
            // 8-16
            // 9-12	
            // 11-13	
            // 12-16	
            // 13-15	
            // Youth	
            // Open	
            let ages = [];
            if (age == 3)   { ages = ['3-5','Youth','Open']; }
            if (age == 4)   { ages = ['3-5','4-5','4-8','Youth','Open']; }
            if (age == 5)   { ages = ['3-5','4-5','4-8','5-8','Youth','Open']; }
            if (age == 6)   { ages = ['4-8','5-8','6-8','Youth','Open']; }
            if (age == 7)   { ages = ['4-8','5-8','6-8','7-9','Youth','Open']; }
            if (age == 8)   { ages = ['4-8','5-8','6-8','7-9','8-10','8-16','Youth','Open']; }
            if (age == 9)   { ages = ['7-9','8-10','8-16','9-12','Youth','Open']; }
            if (age == 10)  { ages = ['8-10','8-16','9-12','Youth','Open']; }
            if (age == 11)  { ages = ['8-16','9-12','11-13','Youth','Open']; }
            if (age == 12)  { ages = ['8-16','9-12','11-13','12-16','Youth','Open']; }
            if (age == 13)  { ages = ['8-16','11-13','12-16','13-15','Youth','Open']; }
            if (age == 14)  { ages = ['8-16','12-16','13-15','Youth','Open']; }
            if (age == 15)  { ages = ['8-16','12-16','13-15','Youth','Open']; }
            if (age == 16)  { ages = ['8-16','12-16','Youth','Open']; }

            results = results.filter(({ attributes }) =>{
                let theages = attributes.age_raw || "[]";
                theages = stringToarray(theages);
                return ages.some( ages => theages.includes(ages) );
            });
        }

        if (length) {
            let lengths = [];
            if (length == "Full Day") { lengths = ['450','480','510','600']; }
            if (length == "Half Day") { lengths = ['210','240']; }
            results = results.filter(({ attributes }) =>{
                let thelengths = attributes.event_length || "[]";
                //onsole.log(Array.from(thelengths));
                //thelengths = stringToarray(thelengths);
                thelengths =String(thelengths);
                return lengths.some( lengths => thelengths.includes(lengths) );
            });
        }

        if (location) {
            results = results.filter(({ relationships }) =>{ 
                let facilities = relationships.facilities || "[]";
                facilities = stringToarray(facilities);                 
                return facilities.some( activityLocation => activityLocation === location );
            });
        }

        if (skillLevel) {
            results = results.filter(filterByValue('skill_level', skillLevel));
        }

        if (ageRange) {
            results = results.filter(filterByValue('age', ageRange));
        }
        if (gender) {
            let genders = [];
            if (gender == "f") { genders = ['f','c']; }
            if (gender == "m") { genders = ['m','c']; }
            if (gender == "c") { genders = ['c']; }
            results = results.filter(({ attributes }) =>{
                let thegenders= attributes.gender || "[]";
                thegenders =String(thegenders);
                return genders.some( genders => thegenders.includes(genders) );
            });
        }
/*
        if (season) {
            results = results.filter(filterByValue('season_id', season));
        }
*/
        if (season) {
            results = results.filter(({ relationships }) =>{ 
                let seasons = JSON.parse (relationships.seasons.replace( /\'/g, "\"" ) );                
                return seasons.some( mySeason => mySeason === season );
            });
        }

        if (dow) {
            const d = dow.split(',');
            results = results.filter(({ relationships }) =>{
                    let temp = relationships.program_dow.replace(/\[/g, "");
                    let temp2 = temp.replace(/]/g, "");
                    let program_dow = temp2.split(','); 
                    return d.some( d => program_dow.includes(d) ) ;//d.some(d => attributes.days_of_week.includes(d))
                });
        }

        if (time) {
            const t = time.split(',');
            results = results.filter(({ relationships }) =>{
                    let temp = relationships.program_timeofday.replace("[", "");
                    let temp2 = temp.replace("]", "");
                    let program_timeofday = temp2.split(','); 
                    return t.some( t => program_timeofday.includes(t) ) ;//d.some(d => attributes.days_of_week.includes(d))
                });
        }
        if (start) {
            // var startdate = new Date(start);
            // startdate.setDate(startdate.getDate() );
            // results = results.filter(({ attributes: { start_date } }) => {
            //     const sda= start_date.split(/[- :]/); //start date array
            //     const new_start_date = new Date(sda[0],sda[1]-1,sda[2],sda[3],sda[4],sda[5]);
            //     return isAfter(new_start_date, new Date(startdate));
            // });
            var startdate = new Date(start);
            startdate.setDate(startdate.getDate() );
            results = results.filter(({ attributes: { end_date } }) => {
                if (end_date) {
                    const eda = end_date.split(/[- :]/); //End date array
                    const new_end_date = new Date(eda[0],eda[1]-1,eda[2],eda[3],eda[4],eda[5]);
                    return isBefore(new Date(startdate),new_end_date);
                } else {
                    return false;
                }
                
            });
        }

        if (end) {
            var enddate = new Date(end);
            enddate.setDate(enddate.getDate() + 1);
            results = results.filter(({ attributes: { end_date } }) => {
                if (end_date) {
                    const eda= end_date.split(/[- :]/); //End date array
                    const new_end_date = new Date(eda[0],eda[1]-1,eda[2],eda[3],eda[4],eda[5]);
                    return isBefore(new_end_date, new Date(enddate))||isEqual(new_end_date, new Date(enddate));
                } else {
                    return false;
                }
            });
        }

        if (facility) {
            results = results.filter(filterByValue('facility_id', facility));
        }
/*
        if (season || dow || time) {
            results = results.filter( validFacilities( filters ) );
        }
  */      
        /*

        if (dow) {
            const d = dow.split(',');
            results = results.filter(({ attributes }) =>
                d.some(d => attributes.days_of_week.includes(d))
            );
        }

        if (location) {
            results = results.filter(filterByValue('facility_id', location));
        }

        
        if (skillLevel) {
            results = results.filter(filterByValue('skill_level_id', skillLevel));
        }

        if (ageRange) {
            results = results.filter(filterByValue('age_range_id', ageRange));
        }

        

        

        if (time) {
            let morning = [];
            let afternoon = [];
            let evening = [];

            if (time.includes('morning')) {
                const start = 0;
                const end = 11;

                morning = results.filter(({ attributes: { start_date } }) => {
                    const hour = getHours(new Date(start_date));

                    return hour >= start && hour <= end;
                });
            }

            if (time.includes('afternoon')) {
                const start = 12;
                const end = 17;

                afternoon = results.filter(({ attributes: { start_date } }) => {
                    const hour = getHours(new Date(start_date));

                    return hour >= start && hour <= end;
                });
            }

            if (time.includes('evening')) {
                const start = 18;
                const end = 23;

                evening = results.filter(({ attributes: { start_date } }) => {
                    const hour = getHours(new Date(start_date));

                    return hour >= start && hour <= end;
                });
            }

            results = [
                ...morning,
                ...afternoon,
                ...evening,
            ];
        }

        if (start) {
            results = results.filter(({ attributes: { start_date } }) => {
                return isAfter(new Date(start_date), new Date(start));
            });
        }

        if (end) {
            results = results.filter(({ attributes: { start_date } }) => {
                return isBefore(new Date(start_date), new Date(end));
            });
        }
*/      



        return setResults(results);
    }

    useEffect(
        () => { fetch(); },
        [ JSON.stringify(filters) ],
    );

    return results;
}
